import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
export const PathLogout = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const menuActive = useSelector((state) => state.menu.activeMenu);
  const navigate = useNavigate();

  useEffect(() => {
    // Installation checks removed; keep default behavior (no redirect to welcome)
  }, []);

  if (user) {
    return <Navigate to={`/${menuActive ? menuActive.url : ''}`} replace />;
  }

  return children;
};
